import * as React from 'react';
import ReactInputMask from 'react-input-mask';
import { BlurEvent } from '../../../utils/customInterface';
import 'bootstrap-datepicker';
import { isNumber } from 'lodash-es';

interface Props {
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur: (e: BlurEvent<HTMLInputElement>) => void;
    onFocus: () => void;
    onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    selectDate?: (e: DatepickerEventObject) => void;
    className: string;
    value: string | number;
    mask: string;
    id?: string;
    placeholder?: string;
    password?: boolean;
    disabled?: boolean;
    type?: string;
    autoComplete?: string;
}

class InputMask extends React.Component<Props, {}> {
    elementTag: string = 'input';
    input: typeof ReactInputMask.prototype;

    componentDidMount(): void {
        const { selectDate } = this.props;
        if (selectDate) {
            $(this.input[this.elementTag]).datepicker({
                format: 'mm/dd/yyyy',
                todayHighlight: true,
                autoclose: true,
                keyboardNavigation: false
            }).on('changeDate', selectDate);
        }
    }

    componentWillUnmount(): void {
        const { selectDate } = this.props;
        if (selectDate) {
            $(this.input[this.elementTag]).datepicker('destroy');
        }
    }
    iconShowDatePicker(): void {
        const { selectDate } = this.props;
        if (selectDate) {
            $(this.input[this.elementTag]).datepicker('show');
        }

    }
    handleClick = (e: React.MouseEvent<HTMLInputElement>): void => {
        const { value, mask } = this.props;
        const input = this.input[this.elementTag];
        if (mask && !isNumber(value)) {
            if (value) {
                const position = value.indexOf('_');
                const clickPosition = input.selectionStart;
                if (clickPosition > position && position !== -1) {
                    input.setSelectionRange(position, position);
                }
            } else {
                input.setSelectionRange(0, 0);
            }
        }

    }

    render(): JSX.Element {
        const { type } = this.props;
        return (
            <ReactInputMask
                ref={(input: typeof ReactInputMask.prototype) => { this.input = input; }}
                type={this.props.password ? 'password' : type ? type : 'text'}
                onClick={this.handleClick}
                disabled={this.props.disabled}
                onChange={this.props.onChange}
                onBlur={this.props.onBlur}
                onFocus={this.props.onFocus}
                className={this.props.className}
                value={this.props.value}
                mask={this.props.mask}
                id={this.props.id}
                placeholder={this.props.placeholder}
                autoComplete={this.props.autoComplete}
                {...this.props.onKeyPress ? { onKeyPress: this.props.onKeyPress } : {}}
            />
        );
    }
}

export default InputMask;


// WEBPACK FOOTER //
// ./src/components/shared/InputMask/InputMask.tsx